<!--
 * @Description: 订单列表页面
 * @Author: gaohc sunhuihong
 * @Date: 2022-03-16 16:43:52
-->
<template>
  <div class="body">
    <el-row style="margin: 25px 40px">
      <el-col :span="4" style="text-align: left">
        <span class="search-title">服务机构：</span>
        <el-select v-model="filterParams.institutionId" filterable clearable size="small"
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'institutionList',
            srcInstitutionList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(visible,
            'institutionList', srcInstitutionList, this)"
          style="width: 120px" placeholder="请输入/选择" @change="handelChangeInst">
          <el-option v-for="item in institutionList" :key="item.id"
            :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">所属医院：</span>
        <el-select v-model="filterParams.hospitalId" size="small" filterable clearable
          :filter-method="interactionUtil.debounce((value) => commonUtil.handleListFilter(value, 'hospitalList',
            srcHospitalList, this))"
          @visible-change="(visible) => commonUtil.handleListFilterVisibleChange(
            visible, 'hospitalList', srcHospitalList, this)"
          style="width: 120px" placeholder="请输入/选择" @change="pageDept">
          <el-option v-for="item in hospitalList" :key="item.id"
            :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="4" style="text-align: center">
        <span class="search-title">科室：</span>
        <el-cascader size="small" style="width: 120px"
          v-model="deptSearchList" clearable filterable :disabled="deptDisabled"
          placeholder="请输入/选择" :options="deptList" :props="{checkStrictly: true,
					expandTrigger: 'hover', children: 'childList', label: 'name', value: 'id'}">
        </el-cascader>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">订单编号：</span>
        <el-input v-model="filterParams.no" size="small" clearable
          style="width: 138px" placeholder="请输入订单编号">
        </el-input>
      </el-col>
      <el-col :span="6" style="text-align: right">
        <span class="search-title">下单时间：</span>
        <el-date-picker v-model="dateRange" style="width: 220px" type="datetimerange"
          align="right" unlink-panels range-separator="至" :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始日期" end-placeholder="结束日期"
          :picker-options="dateRangePickerOptions" size="small">
        </el-date-picker>
      </el-col>
    </el-row>
    <el-row style="margin: 0px 40px 25px 40px; text-align: left">
      <el-col :span="4" style="text-align: left">
        <span class="search-title">服务名称：</span>
        <el-input v-model="filterParams.hserviceName" size="small" clearable
          style="width: 120px" placeholder="服务名称">
        </el-input>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">被服务人：</span>
        <el-input v-model="filterParams.servedPersonNameTeleno" size="small" clearable
          style="width: 120px" placeholder="姓名/手机号">
        </el-input>
      </el-col>
      <el-col :span="4" style="text-align: center">
        <span class="search-title">派单人：</span>
        <el-input v-model="filterParams.distributorNameTeleno" size="small" clearable
          style="width: 120px" placeholder="姓名/手机号">
        </el-input>
      </el-col>
      <el-col :span="5" style="text-align: center">
        <span class="search-title">服务人：</span>
        <el-input v-model="filterParams.serviceNameTeleno" size="small" clearable
          style="width: 138px" placeholder="姓名/手机号">
        </el-input>
      </el-col>
      <el-col :span="6" style="text-align: right">
        <span class="search-title">支付方式：</span>
        <el-select v-model="filterParams.payWay" size="small" filterable
          clearable style="width: 220px" placeholder="请输入/选择">
          <el-option v-for="(item, index) in payWayTypeList" :key="index"
            :label="item.value" :value="item.key * 1">
          </el-option>
        </el-select>
      </el-col>
    </el-row>
    <el-row style="margin: 0px 40px 25px 40px; text-align: left">
      <el-col :span="8" style="text-align: left">
        <el-checkbox v-model="filterParams.isDelegateOrder">
          代客下单
        </el-checkbox>
      </el-col>
      <el-col :span="16" style="text-align: right;">
        <el-button size="small" @click="handleQuery" type="primary" icon="el-icon-search">
          搜 索
        </el-button>
      </el-col>
    </el-row>
    <div class="main-line"></div>
    <el-row style="margin: 25px 40px 7px 0px;">
			<el-col :span="4" style="margin-bottom: 18px;" class="toggle-style" 
        v-model="filterParams.status" v-for="(item, index) in orderStatusCountList" :key="index">
				<span :class="item.select ? 'toggle-list-style' : '' "
					@click="handleOrderStatusItem(item)">
          {{item.statusText + ' ' + '(' + item.count + ')'}}
        </span>
				<span v-if="index != orderStatusCountList.length - 1" class="vertical-line"></span>
			</el-col>
		</el-row>
    <div class="main-line"></div>
    <el-table style="margin: 25px 40px; border: 1px solid #f0f0f0" :style="tableWidth"
      :data="dataTable" :header-cell-style="{'background-color': '#EFF5FA'}">
      <el-table-column label="订单编号" width="150" align="left">
        <template slot-scope="scope"> 
          <span class="overflow-text-style">
            <el-tooltip :content="scope.row.delegateOrderText" placement="top" 
              v-if="scope.row.isDelegateOrder">
					    <span class="replace-order">代</span>
					  </el-tooltip>
            <span class="repeat-order" v-if="scope.row.repurchase">复</span>
            <el-popover placement="bottom" width="181" trigger="hover">
              <span slot="reference">{{scope.row.no ? scope.row.no : '- -'}}</span>
              <div style="display: flex; align-items: flex-end; justify-content: space-between;">
                <span>{{ scope.row.no }}</span>
                <img style="width: 16px; height: 16px; cursor: pointer;" 
                  @click="handleCopyText(scope.row.no)"
                  src="@/assets/ordermng/icon-ordermng-copy.png" alt="">  
              </div>
            </el-popover>
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="genTime" label="下单时间" sortable width="120" align="left">
        <template slot-scope="scope">
          <div style="word-break: break-word;">{{ scope.row.genTime || '- -' }}</div>
        </template>
      </el-table-column>
      <el-table-column label="服务名称" width="120" align="left">
        <template slot-scope="scope">
          <el-popover placement="bottom" width="181" trigger="hover">
            <span slot="reference" class="overflow-text-style">
              {{scope.row.serviceName}}
            </span>
            <div style="display: flex; align-items: flex-end; justify-content: space-between;">
              <span>{{ scope.row.serviceName }}</span>
              <img style="width: 16px; height: 16px; cursor: pointer;" 
                @click="handleCopyText(scope.row.serviceName)"
                src="@/assets/ordermng/icon-ordermng-copy.png" alt="">  
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column label="金额" :sortable="true" :sort-method="sortMethod" 
        align="left" prop="totalAmountYuan" width="100">
        <template slot-scope="scope">
          ￥{{ scope.row.payAmountYuan ? scope.row.payAmountYuan : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="状态" width="100" align="left">
        <template slot-scope="scope">
          {{ scope.row.statusText }}
        </template>
      </el-table-column>
      <el-table-column label="被服务人" width="120" align="left">
        <template slot-scope="scope">
          {{ scope.row.servdePersonName ? scope.row.servdePersonName : "- -" }}
          <div class="sub-text-style">{{scope.row.servdePersonMobile}}</div>
        </template>
      </el-table-column>
      <el-table-column label="派单人" width="120" align="left">
        <template slot-scope="scope">
          {{ scope.row.distributor ? scope.row.distributor : "- -" }}
          <div class="sub-text-style">{{scope.row.dispatcherMobile}}</div>
        </template>
      </el-table-column>
      <el-table-column label="服务人" width="120" align="left">
        <template slot-scope="scope">
          {{ scope.row.serviceNames ? scope.row.serviceNames : "- -" }}
        </template>
      </el-table-column>
      <el-table-column label="服务机构" width="120" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">
            {{scope.row.institutionName ? scope.row.institutionName : '- -'}}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="所属医院" width="120" align="left">
        <template slot-scope="scope">
          <span class="overflow-text-style">
            {{scope.row.hospitalName ? scope.row.hospitalName : '- -'}}
          </span>
          <div class="overflow-text-style sub-text-style">
            {{ scope.row.department1Name ? scope.row.department1Name :'- -' }}
            <span v-if="scope.row.department2Name">/{{ scope.row.department2Name }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="支付方式" width="100" align="left">
        <template slot-scope="scope">
          <span class="text-wrap">
            {{ scope.row.payWayText ? scope.row.payWayText : "- -" }}
            <div class="sub-text-style">
              {{scope.row.paymentModeText}}
            </div>
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right" 
        header-align="center">
        <template slot-scope="scope">
					<el-tooltip content="详情" placement="top">
						<img style="width: 17px; height: 18px; vertical-align: top; cursor: pointer;"
							@click="handleDetailClick(scope.row)" 
              src="@/assets/ordermng/icon-ordermng-detail.png" alt="">
					</el-tooltip>
					<el-tooltip content="订单跟踪" placement="top">
						<img style="width: 20px; height: 20px; margin-left: 10px; vertical-align: top; cursor: pointer;" 
              @click="handleOrderProgress(scope.row)"
              src="@/assets/ordermng/icon-ordermng-progress.png" alt="">
					</el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="foot-pagination">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurPage"
        :current-page="filterParams.page" :page-sizes="pageSizes" :page-size="filterParams.pageSize"
        layout="total,prev, pager, next,sizes,jumper" :total="totalNumber"/>
    </el-row>

    <!-- 订单详情 -->
    <order-details-dialog :visible="showOrderDialog" @check-collectdetails="handleSeeCollectDetails"
      @close-dialog="closeOrderDialog" :orderId="orderId">
    </order-details-dialog>

    <!-- 支付详情 -->
    <payment-details-dialog :visible="showCollectMoneyDialog" @close-dialog="closeDialog"
      :orderId="orderId" />
    
    <!-- 订单跟踪抽屉 -->
    <order-progress-drawer :visible="showOrderProgressDrawer" :orderId="orderId"
      @close-drawer="showOrderProgressDrawer = false"/>
  </div>
</template>

<script>
import Util from '@/global/Util.js'
import Constant from "@/global/Constant.js";
import OrderDetails from "./components/OrderDetails.vue";
import PaymentDetails from "./components/PaymentDetails.vue";
import OrderProgressDrawer from "./components/OrderProgress.vue"

export default {
  name: "OrderList",
  components: {
    "order-details-dialog": OrderDetails,
    "payment-details-dialog": PaymentDetails,
    "order-progress-drawer": OrderProgressDrawer,
  },

  data() {
    return {
      hospitalList: [],
      srcHospitalList: [],
      orderStatusCountList: [],
      payWayTypeList: [],

      filterParams: {
        page: 1,
        pageSize: this.commonConst.PAGE_SIZE,
      },
      pageSizes: this.commonConst.PAGE_SIZES,
      totalNumber: 0,

      institutionList: [],
      srcInstitutionList: [],
      dataTable: [],
      dateRange: null,
      statusList: [],//订单状态选中的集合

      //订单详情dialog变量
      orderId: null,
      showOrderDialog: false,
      dateRangePickerOptions: this.dateUtil.getDateRangePickerOptions(true, false),

      //评估收款详情dialog变量
      showCollectMoneyDialog: false,
      jumpType: "",

      deptDisabled: true,
      deptList: [],
      deptSearchList: [],

      //订单跟踪抽屉变量
      showOrderProgressDrawer: false
    };
  },
  computed: {
    tableWidth() {
      return "width:" + (this.$root.contentWidth - 80) + "px";
    },
  },
  methods: {
    async initView() {
      await this.getOrderListFilterDo();
      this.pageOrderList();
    },

    //订单过滤接口调用
    getOrderListFilterDo() {
      return new Promise((resolve, _reject) => {
        this.appAxios("GET", Constant.URL_GET_ORDER_LIST_FILTER_DO).then((result) => {
            if (result == null) {
              return;
            }

            this.institutionList = result.data.institutionList;
            this.srcInstitutionList = result.data.institutionList;
            this.hospitalList = result.data.hospitalList;
            this.srcHospitalList = result.data.hospitalList;
            let orderStatusCountList = result.data.orderStatusCountList;
            this.rebuildOrderStatusList(orderStatusCountList);
            this.payWayTypeList = this.commonUtil.map2List(result.data.payWayTypeMap);

            if (this.$route.params.institutionId) {
              this.$set(this.filterParams, "institutionId", this.$route.params.institutionId);
            }

            if (this.$route.params.begDate && this.$route.params.endDate) {
              this.$set(this.filterParams, "begDate", this.$route.params.begDate + " " + "00:00:00");
              this.$set(this.filterParams, "endDate", this.$route.params.endDate + " " + "23:59:59");
              this.dateRange = [
                this.$route.params.begDate + " " + "00:00:00",
                this.$route.params.endDate + " " + "23:59:59",
              ];
            }
            resolve();
          }
        );
      });
    },

    //订单管理接口调用
    pageOrderList() {
      if (this.filterParams.hasOwnProperty('begDate') && this.filterParams.begDate == null) {
        delete this.filterParams.begDate;
      }
      if (this.filterParams.hasOwnProperty('endDate') && this.filterParams.endDate == null) {
        delete this.filterParams.endDate;
      }
      if (this.filterParams.hasOwnProperty('hospitalId') && this.filterParams.hospitalId == null) {
        delete this.filterParams.hospitalId;
      }
      if (this.filterParams.hasOwnProperty('statusList') && this.filterParams.statusList == null) {
        delete this.filterParams.statusList;
      }
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_PAGE_ORDER_LIST,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
      this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }

        this.dataTable = result.data;
        this.totalNumber = result.totalNumber;
      });
    },

    //根据选择的医院获取该机构下的科室列表
		pageDept() {
			if (!this.filterParams.hospitalId || this.filterParams.hospitalId == -1) {
				this.deptList = [];
        this.deptSearchList = [];
				this.deptDisabled = true;
				return
			}
      let param= {hspId: this.filterParams.hospitalId};
      let header = this.encryptionUtil.signatureParams(param,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_DEPARTMENT_TREE_DO,
        param: param,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
     	this.vueRequest(requestData).then(result => {
				if (result == null) {
					return
				}
       this.deptList = result.data.childList;
			 this.deptDisabled = false;
     	});
		},

    getOrderStatusCount() {
      if (this.filterParams.hasOwnProperty('begDate') && this.filterParams.begDate == null) {
        delete this.filterParams.begDate;
      }
      if (this.filterParams.hasOwnProperty('endDate') && this.filterParams.endDate == null) {
        delete this.filterParams.endDate;
      }
      if (this.filterParams.hasOwnProperty('hospitalId') && this.filterParams.hospitalId == null) {
        delete this.filterParams.hospitalId;
      }
      let header = this.encryptionUtil.signatureParams(this.filterParams,
        Constant.SIGNATURE_KEY_NAME, Constant.SIGNATURE_KEY);
      let requestData = {
        method: 'GET',
        url: Constant.URL_GET_NEW_ORDER_STATUS_COUNT,
        param: this.filterParams,
        header: header,
        contentType: this.commonConst.CNTYPE_URLENCODED,
      };
     	this.vueRequest(requestData).then(result => {
        if (result == null) {
          return;
        }
        let orderStatusCountList = result.data || [];
        this.rebuildOrderStatusList([...orderStatusCountList]);
      });
    },

    rebuildOrderStatusList(data) {
      let newOrderStatusCountList = data.map(item => ({...item, select: false}));
      if (!this.statusList.length) {
        this.$set(newOrderStatusCountList[0], 'select', true);
      }
      newOrderStatusCountList.forEach(item1 => {
        let foundItem = this.statusList.find(item2 => item2.status == item1.status);
        if (foundItem) {
          item1['select'] = foundItem['select'];
        }
      });
      this.orderStatusCountList = newOrderStatusCountList;
    },

    handleOrderProgress(row) {
      this.orderId = row.id;
      this.showOrderProgressDrawer = true;
    },

    handleDetailClick(item) {
      this.orderId = item.id;
      this.showOrderDialog = true;
    },

    handleCopyText(text) {
      this.commonUtil.copyTextToBoard(this, text);
    },

    //总金额排序
    sortMethod(a, b, _type) {
      return a.totalAmountYuan * 1 > b.totalAmountYuan * 1 ? -1 : 1;
    },

    //点击订单状态可多选
    handleOrderStatusItem(item) {
      if (item.status == -1) {
        this.orderStatusCountList = this.rebuildOrderSelect([...this.orderStatusCountList]);
      } else {
        this.orderStatusCountList[0].select = false;
      }
      item.select = !item.select;
      this.statusList = this.orderStatusCountList.filter(items => items.select);
      let statusIdList = this.statusList.map(items => items.status);
      let newStatusList = [...statusIdList];
      if (newStatusList.length > 1) {
        newStatusList = newStatusList.filter(statusItem => statusItem !== -1);
      }
      this.$set(this.filterParams, 'statusList', newStatusList.join(','));
      if (!this.statusList.length) {
        this.orderStatusCountList[0].select = true;
        this.filterParams.statusList = null;
      }
      this.filterParams.page = 1;
      this.pageOrderList();
    },
    
    rebuildOrderSelect(arr) {
      return arr.map((item) => {
        if (item.status != -1) {
          return {...item, select: false};
        } else {
          return {...item, select: true};
        } 
      });
    },

    //搜索点击
    handleQuery() {
      this.filterParams.begDate = this.dateRange
        ? this.dateUtil.dateTimeFormat(this.dateRange[0]) : null;
      this.filterParams.endDate = this.dateRange
        ? this.dateUtil.dateTimeFormat(this.dateRange[1]): null;
      this.filterParams.page = 1;
      if (this.deptSearchList.length) {
        this.filterParams.department1Id = this.deptSearchList[0] ? this.deptSearchList[0] : "";
        this.filterParams.department2Id = this.deptSearchList[1] ? this.deptSearchList[1] : "";
      } else {
        this.filterParams.department1Id = "";
        this.filterParams.department2Id = "";
      }
      this.getOrderStatusCount();
      this.pageOrderList();
    },

    //查看评估详情
    handleSeeCollectDetails() {
      this.showCollectMoneyDialog = true;
    },

    closeOrderDialog() {
      this.showOrderDialog = false;
    },

    //关闭评估收款详情对话框
    closeDialog() {
      this.showCollectMoneyDialog = false;
    },

    //切换选择服务机构
    handelChangeInst(val) {
      this.filterParams.hospitalId = null;
      this.queryHspListFromInstId(val);
    },

    //根据服务机构Id查询对应机构下的医院列表
    async queryHspListFromInstId(instId) {
      let data = await Util.queryHspListFromInstId(instId, this);
      this.hospitalList = data.hospitalList;
      this.srcHospitalList = data.hospitalList;
    },

    //以下是分页控件操作
    handleSizeChange(val) {
      this.filterParams.pageSize = val;
      this.pageOrderList();
    },

    handleCurPage(curPage) {
      this.filterParams.page = curPage;
      this.pageOrderList();
    },
  },

  mounted() {
    this.$emit("breadcrumb", { text1: "订单管理", text2: "订单列表" });
    this.initView();
  }
};
</script>

<style scoped>
.body {
  margin: 0;
  text-align: center;
  border: solid 0px;
}

.toggle-style {
	font-size: 14px;
	cursor: pointer;
	height: 30px;
	line-height: 30px;
	position: relative;
	color: #000000;
  padding: 0 5px;
}

.toggle-list-style {
	display: inline-block;
	height: 30px;
	line-height: 30px;
	color: #3E7EF5;
	border-bottom: 2px solid #3E7EF5;
}

.vertical-line {
	border-right: 1px solid #DCE1E5;
	position: absolute;
	right: 0px;
	top: 5px;
	height: 20px;
}

.main-line {
  height: 10px;
  background-color: #f0f0f0;
}

.foot-pagination {
  margin-top: 20px;
  text-align: right;
  right: 22px;
  border: solid 0px;
}

.search-title {
  display: inline-block;
  min-width: 70px;
  text-align: right;
  color: #657180;
  font-size: 14px;
}

.replace-order {
  padding: 0 2px;
  height: 18px;
  line-height: 17px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #0FBB9A;
  font-size: 12px;
  color: #0FBB9A;
  cursor: pointer;
}

.repeat-order {
  padding: 0 2px;
  height: 18px;
  line-height: 17px;
  text-align: center;
  border-radius: 3px;
  border: 1px solid #FF4D18;
  font-size: 12px;
  color: #FF4D18;
  margin: 0 4px;
}

.text-wrap {
  display: -webkit-box;
  text-overflow: ellipsis;
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient:vertical;
}

.sub-text-style {
  font-size: 12px;
  color: #888888;
}

.el-table ::-webkit-scrollbar {
    height: 8px;
  }

  .el-table ::-webkit-scrollbar-thumb {
    height: 8px;
  }

  
  .el-table--scrollable-x .el-table__fixed {
    bottom: 8px !important;
  }

  .el-table--scrollable-x .el-table__fixed-right {
    bottom: 8px !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/ordermng/OrderList.vue